import { IconButton } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { Slider } from "components/Slider"
import { useVideoControllerForFlight } from "../controllers/hooks/useController"
import {
    useHasAudio,
    useIsAudioMuted,
    useVolumePercent,
} from "../controllers/hooks/useControllerEvents"
import { GetOrCreateVideoControllerParameters } from "../controllers/VideoControllerFactory"

const QUIET_VOLUME_PERCENT = 50
export const VOLUME_CONTROL_SLIDER_CLASS = "video-audio-volume-slider"

// TODO: @connor @jarren when we get proper designs, clean this up.
export const VideoAudioControls = ({
    flightId,
    options,
    className,
}: GetOrCreateVideoControllerParameters & { className?: string }) => {
    const controller = useVideoControllerForFlight({ flightId, options })
    const hasAudio = useHasAudio({ flightId, options })
    const isMuted = useIsAudioMuted({ flightId, options })
    const volumePercent = useVolumePercent({ flightId, options })

    if (!hasAudio) return null

    const VolumeIcon = isMuted
        ? Icons.VolumeOff
        : volumePercent < QUIET_VOLUME_PERCENT
          ? Icons.VolumeDown
          : Icons.VolumeUp

    return (
        <div className={classNames("flex items-center gap-3", className)}>
            <IconButton
                title={isMuted ? "Unmute" : "Mute"}
                aria-label={isMuted ? "Unmute" : "Mute"}
                className="text-gray-50 flex-shrink-0"
                onClick={(e) => {
                    e.stopPropagation()
                    controller?.setAudioMuted(!isMuted)
                }}
            >
                <Icons.Icon Icon={VolumeIcon} />
            </IconButton>
            <div
                className={classNames("w-20", VOLUME_CONTROL_SLIDER_CLASS)}
                onClick={(e) => e.stopPropagation()}
            >
                <Slider
                    value={isMuted ? 0 : volumePercent}
                    onChange={(value) => controller?.setVolumePercent(value)}
                    size="small"
                />
            </div>
        </div>
    )
}
